import Box from "ds/components/Box";
import Link from "ds/components/Link";

import { ContextCellComponentProps } from "./types";

const ContextNameCell = ({ context, isAdmin = false }: ContextCellComponentProps) => {
  return (
    <Box>
      <Link disabled={!isAdmin} href={`/context/${context.contextId}`}>
        {context.contextName}
      </Link>
    </Box>
  );
};

export default ContextNameCell;
